import React, { useEffect, useState } from 'react'
import moment from 'moment'

import Spinner from '../../components/Spinner'
import trash from '../../assets/images/trash.svg'
import searchSmall from '../../assets/images/SearchIcon.svg'
import downloadIc from '../../assets/images/DownloadButton.svg'
import arrowUp from '../../assets/images/UpArrow.svg'
import folder from '../../assets/images/folder.svg'
import { ApiHelper } from '../../helpers/ApiHelper'
import { API } from '../../config/api'
import Newfile from '../../assets/images/file-plus.svg'
import Newfolder from '../../assets/images/folder-plus.svg'
import Dot from '../../assets/images/dot.svg'
import Option from '../../assets/images/option.svg'
import Tag from '../../assets/images/Tag.svg'
import Info from '../../assets/images/help.svg'
import Add from '../../assets/images/addCirc.svg'
import Modal from 'react-modal';

const FileLibrary = () => {
    const [loader, setLoader] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [fetchedItems, setFetchedItems] = useState([]);
    const [fetchedGroups, setFetchedGroups] = useState([]);
    const [userId, setUserId] = useState('');
    const [groupName, setGroupName] = useState('');
    const [isAddEnabled, setIsAddEnabled] = useState(false);
    const [btnColors, setBtnColors] = useState([
        '#F93A2F', '#FF9534', '#FFB900', '#13DC27', '#61D9FF', '#0065FD', '#7525F6', '#FF09F5'
    ]);
    const [groupStyle, setGroupStyle] = useState({
        backgroundcolor: '#FFB900',
        color: '#302B3A'
    });

    useEffect(() => {
        getUserId();
        fetchData();
    }, []);
    function getUserId() {
        let user = JSON.parse(localStorage.getItem('UserData'));
        setUserId(user.id);
    }
    useEffect(() => {
        if (userId) {
            fetchGroups();
        }
    }, [userId])
    async function fetchData(folderId = '0') {
        setLoader(true);
        const obj = {
            folderid: folderId
        }
        await ApiHelper.post(API.fetchLists, obj)
            .then((resData) => {
                if (resData.data.success === true) {
                    setFetchedItems(resData.data.data);
                }
                setLoader(false);
            })
            .catch((err) => {
                setLoader(false);
            })

    }
    async function deleteItem(itemId, folderId) {
        setLoader(true);
        const obj = {
            documentid: itemId
        }
        await ApiHelper.post(API.deleteListItem, obj)
            .then((resData) => {
                if (resData.data.success === true) {
                    fetchData(folderId)
                }
                setLoader(false);
            })
            .catch((err) => {
                setLoader(false);
            })

    }
    async function fetchGroups() {
        setLoader(true);
        const obj = {
            userid: userId
        }
        await ApiHelper.post(API.fetchGroups, obj)
            .then((resData) => {
                if (resData.data.success === true) {
                    setFetchedGroups(resData.data.data);
                }
                setLoader(false);
            })
            .catch((err) => {
                setLoader(false);
            })
    }
    async function addGroup() {
        setLoader(true);
        let obj = {
            userid: userId,
            name: groupName,
            textcolor: groupStyle.color,
            backgroundcolor: groupStyle.backgroundcolor
        }
        await ApiHelper.post(API.addGroup, obj)
            .then((resData) => {
                if (resData.data.success === true) {
                    setGroupName('');
                    setShowPopup(false);
                    setGroupStyle({
                        backgroundcolor: '#FFB900',
                        color: '#302B3A'
                    });
                    fetchGroups();
                }
                setLoader(false);
            })
            .catch((err) => {
                setLoader(false);
            })

    }
    function toggleStyle(bg, text) {
        if (bg) {
            setGroupStyle({ ...groupStyle, backgroundcolor: bg });
            return;
        }
        setGroupStyle({ ...groupStyle, color: text });
    }
    return (
        <div className='sidebar_open noBg'>
            <section className='secBox px-4 py-3 mb-4'>
                <div className='d-flex' style={{ justifyContent: 'space-between', width: '100%' }}>
                    <div className='inpCheckbx'>
                        <input type="checkbox" /> (2) Selected
                        <button className='btn DltBtn'><img src={trash} alt="test" className="menu_icon" /></button>
                    </div>

                    <div>
                        <div className='serchField'>
                            <img src={searchSmall} alt="test" className="serc_icon" />
                            <input
                                type="text" className='sercInp'
                                placeholder="Search File Library..."
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className='row'>
                    <div className='col-md-8'>
                        <div className='secBox px-4 py-3'>
                            <div className='tableFixHead'>
                                <table className='table fileTable'>
                                    <thead>
                                        <tr>
                                            <th>Name <img src={arrowUp} alt="icon" className="arrow_icon" /></th>
                                            <th>Group <img src={arrowUp} alt="icon" className="arrow_icon" /></th>
                                            <th>Date <img src={arrowUp} alt="icon" className="arrow_icon" /></th>
                                            <th>Actions <img src={arrowUp} alt="icon" className="arrow_icon" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            fetchedItems.map((item) => (
                                                <tr key={item.id} onClick={() => console.log('pressed item')} style={{ cursor: 'pointer' }}>
                                                    <td>
                                                        <div className='frntTxt'>
                                                            <input type="checkbox" />
                                                            <img src={folder} alt="icon" className="folder_icon" />
                                                        </div>
                                                        {
                                                            item.type === 'default' ? item.name : (item.type === 'chatbot' ? item.chatbot_name : item.chatbot_applicant_name)
                                                        }
                                                    </td>
                                                    <td>
                                                        <select>
                                                            <option value="someOption">Corporate Paperwork</option>
                                                            <option value="otherOption">Other option</option>
                                                        </select>
                                                    </td>
                                                    <td>{moment(item.created_at).format('MMMM D, YYYY')}</td>
                                                    <td>
                                                        {
                                                            item.is_folder === 0 && <button className='actionBtn downloadBtn'><img src={downloadIc} alt="icon" className="table_icon" /></button>
                                                        }
                                                        <button onClick={() => deleteItem(item.id, item.parent_id)} className='actionBtn trashBtn'><img src={trash} alt="icon" className="table_icon" /></button>
                                                    </td>
                                                </tr>
                                            ))

                                        }
                                    </tbody>
                                </table>
                            </div>

                            <div className="pagination centPag">
                                <a href="#">&laquo;</a>
                                <a href="#">1</a>
                                <a href="#" className="active">2</a>
                                <a href="#">3</a>
                                <a href="#">4</a>
                                <a href="#">5</a>
                                <a href="#">&raquo;</a>
                            </div>

                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='secBox px-4 py-3 mb-4'>
                            <h6>Create</h6>
                            <ul className='mt-3' >
                                <li className='create-F'><a href='#'><img src={Newfile} alt="icon" className="right_icon" />File Upload</a> </li>
                                <li className='create-F'><a href='#'><img src={Newfolder} alt="icon" className="right_icon" />New Folder</a> </li>
                            </ul>
                        </div>
                        <div className='secBox px-4 py-3 mb-4'>
                            <div className='grp-hd' >
                                <h6>Groups</h6>
                                <img style={{ cursor: 'pointer' }} onClick={() => { setShowPopup(true); setIsAddEnabled(true); }} src={Add} alt="icon" className="right_icon" />
                            </div>
                            <div className='serchField'>
                                <img src={searchSmall} alt="test" className="serc_icon" />
                                <input
                                    type="text" className='sercInp'
                                    placeholder="Search File Library..."
                                />
                            </div>
                            <ul className='mt-3 grp-listing' >
                                {
                                    fetchedGroups.map((item) => (
                                        <li key={item.id} className='create-G'>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '15px', height: '15px', background: item?.background_color !== '#fff' ? item.background_color : '#FFB900', borderRadius: '50%', display: 'inline-block', marginRight: '10px' }} ></div>
                                                {/* <img src={Dot} alt="icon" className="right_icon me-2" /> */}
                                                {item.group_name}
                                            </div>
                                            <img src={Option} alt="icon" className="right_icon group-Add" />
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        <div className='secBox px-4 py-3 mb-4'>
                            <ul className='status-ind mb-0' >
                                <li className='mb-0'>
                                    <a href='#' className='d-flex justify-content-center'><img src={Info} alt="copy" className="create-icon mb-0 me-2" />Need Help?</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <Modal isOpen={showPopup} ariaHideApp={false}>
                <div>
                    <div className="modal-header">
                        <h5 className="modal-title">{isAddEnabled ? 'Add' : 'Edit'} Group </h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={() => {
                            setShowPopup(false); setGroupName(''); setIsAddEnabled(false); setGroupStyle({
                                backgroundcolor: '#FFB900',
                                color: '#302B3A'
                            });
                        }}></button>
                    </div>
                    <div className="modal-body file-edit">


                        <div className='row'>
                            <div className='col-lg-12'>
                                <div className='form-group'>
                                    <label className='form-label' > {isAddEnabled ? 'Add Group' : 'Edit Group Name'}</label>
                                    <input type='text' className='form-control' placeholder='Enter group name' value={groupName} onChange={(e) => setGroupName(e.target.value)} ></input>
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className='form-group preview_s'>
                                    <label className='form-label' >Preview: </label>
                                    <span className='preview' style={{ backgroundColor: groupStyle.backgroundcolor, color: groupStyle.color }} >Corporate Paperwork</span>
                                    <label className='form-label' >Pick from the colors below.   </label>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <div className='form-group'>
                                    <label className='form-label' >Background Color:  </label>
                                    <div className='color-btn-grp'>
                                        {
                                            btnColors.map((color, index) => (
                                                <button key={index} onClick={() => toggleStyle(color, null)} className={groupStyle.backgroundcolor === color ? 'selected' : ''}></button>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <div className='form-group'>
                                    <label className='form-label' >Text Color:  </label>
                                    <div className='color-btn-grp text'>
                                        <button onClick={() => toggleStyle(null, '#302B3A')} className={groupStyle.color === '#302B3A' ? 'selected' : ''}></button>
                                        {/* <button onClick={() => toggleStyle(null, '#fff')} className={groupStyle.color === '#fff' ? 'selected' : ''}></button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer mt-5">
                        <button type="button" className="btn btn-primary cancel me-3" onClick={() => {
                            setShowPopup(false); setGroupName(''); setIsAddEnabled(false); setGroupStyle({
                                backgroundcolor: '#FFB900',
                                color: '#302B3A'
                            });
                        }}>Cancel</button>
                        <button type="button" className="btn btn-primary save-pop save-update" onClick={() => addGroup()}>Save</button>
                    </div>
                </div>
            </Modal>
            {loader && <Spinner />}
        </div>
    )
}

export default FileLibrary











